<script>
import { Divider } from "element-ui";
export default {
  components: { [Divider.name]: Divider },
  data() {
    return {
      search: null,
      show_filters: this.defaultShowFilters,
    };
  },
  methods: {
    toggleFilters() {
      this.show_filters = !this.show_filters;
      this.$emit("showfilters", this.show_filters);
    },
    enter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
      void el.offsetHeight;
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    afterEnter(el) {
      el.style.height = null;
      el.style.opacity = null;
      el.style.transition = null;
    },
    leave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
      void el.offsetHeight;
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = "0";
      el.style.opacity = "0";
    },
    afterLeave(el) {
      el.style.height = null;
      el.style.opacity = null;
      el.style.transition = null;
    },
  },
  props: {
    modelName: {
      type: Object,
      default(rawProps) {
        return {
          singular: "",
          plural: "",
        };
      },
    },
    value: {
      type: String,
      default: null,
    },
    defaultShowFilters: {
      type: Boolean,
      default: false,
    },
    hideDefaultButtons: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.search = this.value;
    },
    search() {
      this.$emit("input", this.search);
    },
  },
};
</script>

<template>
  <div>
    <!-- For XL and Above -->
    <div class="row d-none d-xxl-flex align-items-center mb-4">
      <!-- Left Section: Search Bar and Filter Button -->
      <div class="col-4 d-flex align-items-center">
        <div class="search-box flex-grow-1 me-2" style="max-width: 300px;">
          <div class="position-relative">
            <base-input id="filter-input" v-model="search" type="search" :placeholder="`Search ${modelName.plural}`" delay @enter="$emit('search', $event)" />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
        <b-button :variant="show_filters ? 'primary' : 'secondary'" @click="toggleFilters" style="width:45px">
          <i class="bx bx-filter-alt fw-bold"></i>
          <!-- {{ show_filters ? "Hide" : "Show" }} Filters -->
        </b-button>
      </div>
      <div class="col-4">
        <h5 class="mb-0 text-uppercase fw-bold text-center">{{ modelName.plural }}</h5>
      </div>
      <div class="col-4 d-flex justify-content-end">
        <div v-if="!$slots['custom-buttons'] && !hideDefaultButtons" class="d-flex gap-2">
          <b-button v-if="!$slots['custom-buttons']" variant="primary" @click="$emit('create')">
            <span class="d-flex align-items-center justify-content-center"><i class="bx bx-plus p-0 me-2"></i>New {{ modelName.singular }}</span>
          </b-button>
        </div>
        <slot name="custom-buttons"></slot>
      </div>
    </div>

    <!-- For Below XL -->
    <div class="d-flex flex-column d-xxl-none mb-2">
      <div class="text-center mb-3">
        <h5 class="mb-0 text-uppercase fw-bold">{{ modelName.plural }}</h5>
      </div>
      <div class="d-block d-md-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center mb-2 mb-md-0">
          <div class="search-box w-100 flex-grow-1 me-2" style="min-width: calc(27vw);">
            <div class="position-relative">
              <base-input id="filter-input" v-model="search" type="search" :placeholder="`Search ${modelName.plural}`" delay @enter="$emit('search', $event)" />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
          <b-button :variant="show_filters ? 'primary' : 'secondary'" @click="toggleFilters" style="min-width: 45px;">
            <i class="bx bx-filter-alt fw-bold" ></i>
          </b-button>
        </div>
        <div class="d-block d-flex d-sm-block flex-column text-center text-md-end w-100 gap-2">
          <b-button v-if="!$slots['custom-buttons'] && !hideDefaultButtons" variant="primary" @click="$emit('create')">
            <span class="d-flex align-items-center justify-content-center"><i class="bx bx-plus p-0 me-2"></i>New {{ modelName.singular }}</span>
          </b-button>
          <slot name="custom-buttons"></slot>
        </div>
      </div>
    </div>
    <transition
      name="collapse"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <div v-show="show_filters">
        <base-card>
          <h5 class="card-title">Filters</h5>
          <div class="filters-grid">
            <slot name="filters"></slot>
          </div>
        </base-card>
      </div>
    </transition>
  </div>
</template>

<style scoped>
  .filters-grid {
    display: grid;
    row-gap: 8px;
    column-gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .collapse-enter-active,
  .collapse-leave-active {
    overflow: hidden;
  }

</style>